import sanitize from "./helpers/sanitize";

const studiesSelect = () => {
    if (document.querySelector('.ume-neurologie-studies-holder')) {
        const holder = document.querySelector('.ume-neurologie-studies-holder');
        holder.addEventListener('change', ev => {
            if (!ev.target.classList.contains('ume-neurologie-study-checkbox')) return;
            const hiddenField = document.querySelector('.ume-neurologie-hidden-studies');
            let hiddenFieldValue = sanitize(hiddenField.value);
            let hiddenFieldArray = [];
                if(hiddenFieldValue !== ''){
                    hiddenFieldArray = hiddenFieldValue.split(',');
                }

            let currentValue = sanitize(ev.target.getAttribute('data-study-name'));

            if (ev.target.checked && !hiddenFieldArray.includes(currentValue)) {
                hiddenFieldArray.push(currentValue);
                hiddenFieldValue = hiddenFieldArray.join();
                hiddenField.value = hiddenFieldValue;
                return;
            }
            if (hiddenFieldArray.includes(currentValue)) {
                let index = hiddenFieldArray.indexOf(currentValue);
                if (index > -1) {
                    hiddenFieldArray.splice(index, 1);
                }
                hiddenFieldValue = hiddenFieldArray.join();
                hiddenField.value = hiddenFieldValue;
            }
        });
    }
}
export default studiesSelect;